import React, { useState, useEffect } from 'react';
import { Bed, Bath, MapPin, Home } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const PropertyListAdminHorizontal = ({ properties = [], openModal, currency }) => {
  const { t } = useTranslation();
  const [visibleCount, setVisibleCount] = useState(8);
  const [isMobile, setIsMobile] = useState(false);




   const [alertedProperties, setAlertedProperties] = useState({}); // เก็บ property_id ที่แจ้งเตือนแล้ว

useEffect(() => {
  const today = new Date();

  properties.forEach((property) => {
    if (property.status !== 'Rented') return;
    if (!property.rentalEndDate) return;

    const endDate = new Date(property.rentalEndDate);
    const diffDays = (endDate - today) / (1000 * 60 * 60 * 24);

    if (diffDays <= 30 && diffDays >= 0) {
      const alertKey = `rentalAlert_${property.property_id}`;
      const lastAlert = localStorage.getItem(alertKey);
      const lastAlertDate = lastAlert ? new Date(lastAlert) : null;

      // ตรวจว่ามี alert ใน session หรือ localStorage
      if (!alertedProperties[property.property_id] &&
          (!lastAlertDate || (today - lastAlertDate) / (1000 * 60 * 60 * 24) >= 5)) {

        alert(`⚠️ Rental ending soon!\nProperty: ${property.name}\nID: ${property.property_id}\nUntil: ${endDate.toLocaleDateString()}`);

        localStorage.setItem(alertKey, today.toISOString());
        setAlertedProperties(prev => ({ ...prev, [property.property_id]: true }));
      }
    }
  });
}, [properties, alertedProperties]);






  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // ตรวจครั้งแรก
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm(t("confirm_delete"))) {
      try {
        const response = await fetch(`https://summerhousagentlive.onrender.com/api/properties/${id}`, {
          method: 'DELETE',
        });
        if (response.ok) {
          alert(t("delete_success"));
          window.location.reload();
        } else {
          alert(t("delete_failed"));
        }
      } catch (error) {
        console.error("เกิดข้อผิดพลาด:", error);
        alert(t("delete_error"));
      }
    }
  };

  const formatPrice = (price) => {
    if (!price) return '-';
    const exchangeRate = 36;
    const numericPrice = Number(price);
    if (isNaN(numericPrice)) return price;

    return currency === 'THB'
      ? `${numericPrice.toLocaleString()} ฿`
      : `${(numericPrice / exchangeRate).toFixed(2)} $`;
  };

  const displayedProperties = properties.slice(0, visibleCount);
  const handleLoadMore = () => setVisibleCount(prev => prev + 8);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', width: '100%'  }}>
      {displayedProperties.map(property => (
        <div 
          key={property.property_id} 
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '10px' : '15px',
            padding: isMobile ? '12px' : '15px',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            backgroundColor: '#fff',
            alignItems: isMobile ? 'flex-start' : 'center',
            cursor: 'pointer',
            position: 'relative',
            color: 'black'
          }}
          onClick={() => openModal(property)}
        >
          {/* ปุ่มลบ */}
          <button 
            style={{
              position: 'absolute',
              top: '10px',
              left: '10px',
              backgroundColor: '#e74c3c',
              color: '#fff',
              border: 'none',
              borderRadius: '50%',
              width: '30px',
              height: '30px',
              fontSize: '20px',
              cursor: 'pointer',
              lineHeight: '30px',
              textAlign: 'center',
              zIndex: 10,
            }}
            onClick={(e) => { e.stopPropagation(); handleDelete(property.property_id); }}
          >
            ×
          </button>

          {/* มุมขวาบน: Hot Deal / Furnished / Status */}
          {/* Badge / Status */}
{isMobile ? (
  <div style={{  display: 'flex',
  gap: '6px',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',  // ✅ ชิดขวา
  marginTop: '5px',
  width: '100%'}}>
    {property.featured && <span style={styles.hotDealInline}>🔥 Hot Deal</span>}
    
    {property.furnished && <span style={styles.furnishedInline}>{t("Furnished_full")}</span>}
    {property.status && (
      <span
        style={{
          ...styles.statusInline,
          backgroundColor:
            property.status === "Buy"
              ? "#F39C12"
              : property.status === "Rent"
              ? "#3498db"
              : property.status === "Rented"
              ? "#E74C3C"
              : property.status === "Sold Out"
              ? "#e74c3c"
              : "#95a5a6",
        }}
      >
        {t(property.status)}
                  </span>
                )}  <span>{t('sha_id')}: {property.property_id}</span>{t('By')} :  {property.username}
              </div>
            ) : (
              // แบบ desktop ยังคงอยู่มุมขวาบน
              <div style={{
                
                position: 'absolute',
                top: '10px',
                right: '10px',
                fontSize: '12px',
                color: '#555',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                flexWrap: 'wrap'
              }}>
                {property.featured && <span style={styles.hotDealInline}>🔥 Hot Deal</span>}
                {property.furnished && <span style={styles.furnishedInline}>{t("Furnished_full")}</span>}
                {property.status && (
                  <span
                    style={{
                      ...styles.statusInline,
                      backgroundColor:
                        property.status === "Buy"
                          ? "#F39C12"
                          : property.status === "Rent"
                          ? "#3498db"
                          : property.status === "Rented"
                          ? "#E74C3C"
                          : property.status === "Sold Out"
                          ? "#e74c3c"
                          : "#95a5a6",
                    }}
                  >
                    {t(property.status)}
                
                    
                  </span>
                )}
                <span>{t('sha_id')}: {property.property_id}</span>
                {t('By')} :  {property.username}
                

              </div>
            )}


          {/* รูปภาพ */}
          {property.images && property.images[0] && (
            <img
              src={property.images[0]}
              alt={property.name}
              style={{
                width: isMobile ? '100%' : '120px',
                height: isMobile ? '200px' : '90px',
                objectFit: 'cover',
                borderRadius: '8px'
              }}
            />
          )}

          {/* ข้อมูลทรัพย์ */}
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: isMobile ? '10px' : '6px',
            marginTop: isMobile ? '5px' : 0,
            width: '100%'
          }}>
            <h3 style={{
              margin: 0,
              fontSize: isMobile ? '1rem' : '1rem',
              fontWeight: '600'
            }}>
              {property.name}
            </h3>

            <div style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? '6px' : '10px',
              fontSize: isMobile ? '0.8rem' : '0.7rem',
              color: '#555',
              flexWrap: 'wrap'
            }}>
              <div>{formatPrice(property.price)}</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <MapPin size={14} /> {t(property.location)}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Home size={14} /> {t(property.type)}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Bed size={14} /> {property.bedrooms ?? '-'}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Bath size={14} /> {property.bathrooms ?? '-'}
              </div>
          {property.status === 'Rented' && property.rentalEndDate && (
            <span style={{
              backgroundColor: '#2ecc71',
              color: 'white',
              padding: '2px 6px',
              borderRadius: '6px',
              fontSize: '11px',
              fontWeight: 'bold'
            }}>
              🕒 Until: {new Date(property.rentalEndDate).toLocaleDateString()}
            </span>
          )}
              <button
                onClick={(e) => { e.stopPropagation(); window.location.href = `/edit/${property.property_id}`; }}
                style={{
                  backgroundColor: '#27ae60',
                  color: '#fff',
                  padding: isMobile ? '6px 10px' : '4px 8px',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: isMobile ? '0.9rem' : '0.85rem',
                  width: isMobile ? '100%' : 'auto'
                }}
              >
                {t("Edit")}
                  
               
              </button>
              
            </div>
          </div>
        </div>
      ))}

      {/* ปุ่มโหลดเพิ่ม */}
      {visibleCount < properties.length && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            onClick={handleLoadMore}
            style={{
              padding: '12px 25px',
              fontSize: '16px',
              fontWeight: '600',
              backgroundColor: '#dd9e2a',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
              fontFamily: "'Roboto Condensed', 'Kanit', sans-serif"
            }}
            onMouseOver={e => e.currentTarget.style.backgroundColor = '#c4871f'}
            onMouseOut={e => e.currentTarget.style.backgroundColor = '#dd9e2a'}
          >
            {t("See more")}
          </button>
        </div>
      )}
    </div>
  );
};

const styles = {
  hotDealInline: {
    background: 'linear-gradient(135deg, #ffa733, #ff6b00, #cc5200)',
    color: '#fff',
    padding: '2px 6px',
    borderRadius: '6px',
    fontSize: '11px',
    fontWeight: 'bold'
  },
  furnishedInline: {
    background: 'linear-gradient(90deg, #1a8cff, #0a71e7)',
    color: '#fff',
    padding: '2px 6px',
    borderRadius: '6px',
    fontSize: '11px',
    fontWeight: 'bold'
  },
  statusInline: {
    color: "#fff",
    padding: "3px 8px",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "bold",
    marginLeft: "6px",
    textTransform: "uppercase",
  },
};

export default PropertyListAdminHorizontal;
